import { render } from "./CommentsSection.vue?vue&type=template&id=4ede0ab1"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__